import React from 'react';
import { Container, Typography, Grid, Card, CardContent, CardMedia, Box, Rating } from '@mui/material';
import { FormatQuote } from '@mui/icons-material';
import '../styles/animations.css';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Rajesh Kumar',
      role: 'Property Investor',
      image: '/images/testimonials/rajesh.jpg',
      rating: 5,
      text: 'I have invested in multiple properties through 4 Roots Realty. Their market knowledge and professional approach have always helped me make the right investment decisions.',
      video: 'https://www.youtube.com/embed/VIDEO_ID_1'
    },
    {
      id: 2,
      name: 'Priya Sharma',
      role: 'Homeowner',
      image: '/images/testimonials/priya.jpg',
      rating: 5,
      text: 'The team at 4 Roots Realty made my home buying journey smooth and hassle-free. They understood my requirements perfectly and showed me properties that matched my criteria.',
      video: 'https://www.youtube.com/embed/VIDEO_ID_2'
    },
    {
      id: 3,
      name: 'Amit Patel',
      role: 'Business Owner',
      image: '/images/testimonials/amit.jpg',
      rating: 4,
      text: 'Found the perfect commercial space for my business through 4 Roots Realty. Their expertise in commercial real estate is commendable.',
      video: 'https://www.youtube.com/embed/VIDEO_ID_3'
    }
  ];

  return (
    <Container sx={{ py: 8 }}>
      <Typography 
        variant="h2" 
        align="center" 
        gutterBottom
        className="animate-fadeInUp"
      >
        Client Testimonials
      </Typography>
      <Typography 
        variant="h5" 
        align="center" 
        color="text.secondary" 
        paragraph
        className="animate-fadeInUp delay-100"
      >
        What our clients say about us
      </Typography>

      <Grid container spacing={4}>
        {testimonials.map((testimonial, index) => (
          <Grid item xs={12} key={testimonial.id}>
            <Card 
              sx={{ display: { md: 'flex' }, height: '100%' }}
              className={`animate-slideInFromRight hover-scale delay-${index * 200}`}
            >
              <Box sx={{ flex: 1, p: 3 }}>
                <CardContent>
                  <Box 
                    sx={{ display: 'flex', alignItems: 'center', mb: 2 }}
                    className="animate-fadeInUp delay-100"
                  >
                    <CardMedia
                      component="img"
                      sx={{ width: 80, height: 80, borderRadius: '50%', mr: 2 }}
                      image={testimonial.image}
                      alt={testimonial.name}
                    />
                    <Box>
                      <Typography variant="h6">
                        {testimonial.name}
                      </Typography>
                      <Typography variant="subtitle1" color="text.secondary">
                        {testimonial.role}
                      </Typography>
                      <Rating value={testimonial.rating} readOnly />
                    </Box>
                  </Box>

                  <Box 
                    sx={{ display: 'flex', mb: 2 }}
                    className="animate-fadeInUp delay-200"
                  >
                    <FormatQuote sx={{ fontSize: 40, color: 'primary.main' }} />
                    <Typography variant="body1" paragraph>
                      {testimonial.text}
                    </Typography>
                  </Box>
                </CardContent>
              </Box>

              <Box 
                sx={{ width: { md: '50%' }, minHeight: 300 }}
                className="animate-scaleIn delay-300"
              >
                <iframe
                  width="100%"
                  height="100%"
                  src={testimonial.video}
                  title={`Testimonial by ${testimonial.name}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Submit Testimonial Section */}
      <Box 
        sx={{ mt: 8, textAlign: 'center' }} 
        className="animate-fadeInUp delay-400"
      >
        <Typography variant="h4" gutterBottom>
          Share Your Experience
        </Typography>
        <Typography variant="body1" paragraph>
          We value your feedback. Submit your testimonial through our form.
        </Typography>
        <Box 
          sx={{ mt: 4 }}
          className="animate-scaleIn delay-500"
        >
          <iframe
            src="https://docs.google.com/forms/d/e/YOUR_TESTIMONIAL_FORM_ID/viewform?embedded=true"
            width="100%"
            height="600"
            frameBorder="0"
            marginHeight={0}
            marginWidth={0}
          >
            Loading…
          </iframe>
        </Box>
      </Box>
    </Container>
  );
};

export default Testimonials; 